// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ToggleIcon_toggle__5yx8J {
    width: 22px;
    height: 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: var(--dark-grey);
    transition: transform 0.4s;
    transform: rotate(90deg);
    max-width: 100%;
    max-height: 100%;
}

.ToggleIcon_toggle__5yx8J.ToggleIcon_secondary__ZRtQf {
    transform: rotate(-180deg);
}

details[open] .ToggleIcon_toggle__5yx8J,
.ToggleIcon_toggle__5yx8J.ToggleIcon_active__UHPcL {
    transform: rotate(180deg);
    color: var(--primary-color);
}

.ToggleIcon_toggle__5yx8J.ToggleIcon_secondary__ZRtQf.ToggleIcon_active__UHPcL {
    transform: rotate(0deg);
}

.ToggleIcon_toggle__5yx8J.ToggleIcon_secondary__ZRtQf {
    width: 18px;
}

@media ${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]} {
    .ToggleIcon_toggle__5yx8J {
        width: 15px;
        height: 15px;
    }

    .ToggleIcon_toggle__5yx8J.ToggleIcon_secondary__ZRtQf {
        width: 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/ToggleIcon/ToggleIcon.module.css"],"names":[],"mappings":"AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,wBAAwB;IACxB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["@value screen-md-max from '../../breakpoints.css';\n\n.toggle {\n    width: 22px;\n    height: 15px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--dark-grey);\n    transition: transform 0.4s;\n    transform: rotate(90deg);\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.toggle.secondary {\n    transform: rotate(-180deg);\n}\n\ndetails[open] .toggle,\n.toggle.active {\n    transform: rotate(180deg);\n    color: var(--primary-color);\n}\n\n.toggle.secondary.active {\n    transform: rotate(0deg);\n}\n\n.toggle.secondary {\n    width: 18px;\n}\n\n@media screen-md-max {\n    .toggle {\n        width: 15px;\n        height: 15px;\n    }\n\n    .toggle.secondary {\n        width: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"toggle": `ToggleIcon_toggle__5yx8J`,
	"secondary": `ToggleIcon_secondary__ZRtQf`,
	"active": `ToggleIcon_active__UHPcL`
};
export default ___CSS_LOADER_EXPORT___;
